import { createSelector } from 'reselect';
import { getSelectableMerchants } from '@/selectors/merchant';

export const getSelectableMids = createSelector(getSelectableMerchants, (merchants = []) =>
  merchants.map(({ id } = {}) => id),
);
